<template>
  <tr>
    <td class="align-middle" style="width: 160px;">{{ rewardData.name }}</td>
    <td class="align-middle">{{ rewardData.reference }}</td>
    <td style="width: 70px;" class="align-middle">
      <d-button
        theme="danger"
        size="sm"
        :disabled="removeInProgress"
        @click.prevent="removeReward"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'rewards-list-item',
  props: {
    rewardData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      removeInProgress: false
    };
  },
  methods: {
    removeReward () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/rewards/delete/',
        id: parseInt(this.rewardData.id, 10),
        successTitle: 'Reward removed',
        successText: 'The selected reward has been removed',
        confirmTitle: 'Do you really want to remove this reward?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('rewards-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
